import { Button } from '@strata/react-buttons';
import { WarningDialog } from '@strata/react-dialog';
import { DetailValue } from '@strata/react-label-value-pairs';
import { useFormikContext } from 'formik';
import PropTypes from 'prop-types';

import {
    filterListItems,
    getListItemName,
    ListType,
    ListTypeItemKeyMap,
    pluralizeListTypeName,
} from 'services/ListManagementHelpers';

export const DeleteListItemsDialog = ({ listType }) => {
    const formik = useFormikContext();

    let listTypeName = getListItemName(listType);
    if (formik.values.itemsToDelete.length > 1) {
        listTypeName = pluralizeListTypeName(listTypeName);
    }
    return (
        <WarningDialog
            dialogTitle="Confirm Delete"
            width={600}
            isOpen={formik.values.itemsToDelete.length > 0}
            primaryButtonIntent={Button.Intent.DANGER}
            primaryButtonLabel={`Yes, Delete ${listTypeName}`}
            secondaryButtonLabel="No, Cancel"
            onPrimaryButtonClick={() =>
                formik.setValues({
                    ...formik.values,
                    listItems: filterListItems(
                        formik.values.listItems,
                        formik.values.itemsToDelete,
                        listType,
                    ),
                    addedItems: filterListItems(
                        formik.values.addedItems,
                        formik.values.itemsToDelete,
                        listType,
                    ),
                    deletedItems: [
                        ...formik.values.deletedItems,
                        ...filterListItems(
                            formik.values.itemsToDelete,
                            formik.values.deletedItems,
                            listType,
                        ),
                    ],
                    selected: [],
                    itemsToDelete: [],
                })
            }
            onSecondaryButtonClick={() => formik.setFieldValue('itemsToDelete', [])}
            dialogContent={
                <>
                    <p className="margin__bottom--large">
                        Are you sure you want to delete the following {listTypeName}?
                    </p>
                    {formik.values.itemsToDelete.map((item) => {
                        const listItemStr = (
                            listType === ListType.product
                                ? [ListTypeItemKeyMap[listType][0]]
                                : ListTypeItemKeyMap[listType]
                        )
                            .map((key) => item[key])
                            .join(' - ');
                        return (
                            <div key={listItemStr} className="margin__bottom--small">
                                <DetailValue value={listItemStr} />
                            </div>
                        );
                    })}
                </>
            }
        />
    );
};

DeleteListItemsDialog.propTypes = {
    listType: PropTypes.string.isRequired,
};
